/**
 * Get the value by the given key
 * 
 * @param {any} object 
 * @param {string} key 
 * @param {any} defaultValue
 * @returns {any}
 */
export default function get(object: any, key: string, defaultValue: any = null): any {
    try {
        const value = key.split(".").reduce((obj, property) => (obj || {})[property], object);

        return value !== undefined ? value : defaultValue
    } catch (error) {
        return defaultValue
    }
}